import * as actionTypes from '../../constants/actionTypes';

export const fetchExhibFloorInfoRequest = (data) => ({
   type: actionTypes.FETCH_EXHIBFLOOR_INFO_REQUEST,
   payload: data
})
export const fetchExhibFloorInfoSuccess = (data) => ({
   type: actionTypes.FETCH_EXHIBFLOOR_INFO_SUCCESS,
   payload: data
})
export const fetchExhibFloorInfoFailure = (data) => ({
   type: actionTypes.FETCH_EXHIBFLOOR_INFO_FAILURE,
   payload: data
})

export const fetchCompanyInfoRequest = (data) => ({
   type: actionTypes.FETCH_COMPANY_INFO_REQUEST,
   payload: data
})
export const fetchCompanyInfoSuccess = (data) => ({
   type: actionTypes.FETCH_COMPANY_INFO_SUCCESS,
   payload: data
})
export const fetchCompanyInfoFailure = (data) => ({
   type: actionTypes.FETCH_COMPANY_INFO_FAILURE,
   payload: data
})

export const fetchTagsInfoRequest = (data) => ({
   type: actionTypes.FETCH_TAGS_REQUEST,
   payload: data
})
export const fetchTagsInfoSuccess = (data) => ({
   type: actionTypes.FETCH_TAGS_SUCCESS,
   payload: data
})
export const fetchTagsInfoFailure = (data) => ({
   type: actionTypes.FETCH_TAGS_FAILURE,
   payload: data
})

export const setFIlterSelectedItems = (data) => ({
   type: actionTypes.SET_FILTER_SELECTED_ITEMS,
   payload: data
})

export const setAppConfigData = (data) => ({
   type: actionTypes.FETCH_EXHIBFLOOR_INFO_SUCCESS,
   payload: data
})

export const fetchBoothConfigurationRequest = (data) => ({
   type: actionTypes.FETCH_BOOTH_CONFIGURATION_REQUEST,
   payload: data
})
export const fetchBoothConfigurationSuccess = (data) => ({
   type: actionTypes.FETCH_BOOTH_CONFIGURATION_SUCCESS,
   payload: data
})
export const fetchBoothConfigurationFailure = (data) => ({
   type: actionTypes.FETCH_BOOTH_CONFIGURATION_FAILURE,
   payload: data
})

export const updateExhibitorHashMap = (data) => ({
   type: actionTypes.UPDATE_EXHIBITOR_HASH_MAP,
   payload: data
})

export const handleBoothListLoader = (data) => ({
   type: actionTypes.HANDLE_BOOTH_LIST_LOADER,
   payload: data
})
export const updateCustomThemeStyle = (data) => ({
   type: actionTypes.UPDATE_CUSTOM_THEME_STYLE,
   payload: data
})
export const updateIsEmbed = (data) => ({
   type: actionTypes.UPDATE_IS_EMBED,
   payload: data
});

export const updateIsDirectoryEmbed = (data) => ({
   type: actionTypes.UPDATE_IS_DIRECTORY_EMBED,
   payload: data
})